import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { ClientEmailDO } from 'app/BaseFramework/shared/models'
import { ErrorDO } from 'app/BaseFramework/shared/models/error.model';

interface ValidationOutput {
  isInvalid: boolean,
  errorDOs: Array<ErrorDO>
}
@Component({
  selector: 'app-email-list-details',
  templateUrl: './email-list-details.component.html',
  styleUrls: ['./email-list-details.component.scss']
})
export class EmailListDetailsComponent implements OnInit {

  _currentComponentName = 'EmailListDetailsComponent'

  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private notification: NzNotificationService,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private appMetadataHandler: AppMetadataHandler,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService) { }

  //Declaraions which might need developer input
  uiMultirowBasicForm: FormGroup
  UIMULTIROWBASICFORMNAME = "uiMultirowBasicForm"
  lookupsToBind = ['emailTypeCd']
  selectorOfThisComponent = 'app-claims-basic-details'
  parentEvent$
  emailFieldValidation = [{ validation: 'email', errorMessage: "This field is invalid" }];
  isReadOnly : boolean = this.appMetadataHandler.isReadOnly;
  /**
     *
     *  Ninad: Whenever any developer is creating a new Component,
     * please make sure that you copy all import commands, constructor and
     * Boiler and Component Creation Kickstart CODE 
     *
     * 
     * Component Creation Kickstart CODE 
     */

  //ComponentSpecific Inputs, Outputs

  @Input() placeholderVal: string = '';
  searchHasData: boolean = false;
  searchTerm: string = '';
  lookupTypeCd: string = 'emailTypeCd';
  type: string = 'email';
  item
  @Output() componentOutput = new EventEmitter<any>();
  private _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    if (value) {

      this._inputDataForEdit = value;
      this.initializeClientSearchForm(this._inputDataForEdit)
      this.ServerToUITransform(this._inputDataForEdit);
    }else{
      this.emailList = [];
    }

  };

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput, this.UItoServerTransform)
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
    } catch { }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
    } catch { }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.uiMultirowBasicForm.value.emailId)) {
        this.addEmailToList();
        this.EmitComponentOutput(this.emailList)
      }else{
        let isOutputValid = this.validateOutput(this.uiMultirowBasicForm)
        // if (isOutputValid) {
        //   this.EmitComponentOutput(this.emailList)
        // }
        // else {
        //   this.EmitComponentOutput("ERROR")
        // }
        /**Throw the error if invalid value id ther, for blank record just emit the list**/
        if(this.uiMultirowBasicForm.value.emailId){
          let validationOutput: ValidationOutput = {
            isInvalid: null,
            errorDOs: []
          }

          let invalidFields = [];
          let errorDO = new ErrorDO();
          errorDO.errorMsg = "Please enter valid email";
          errorDO.validationLevel = null
          errorDO.validationEvent = "save"
          errorDO.fieldName = "Email";
          errorDO.validationType = 'email'
          errorDO.fieldNameDescription = "Contact Detail Email"
          errorDO.componentName = this.getCurrentComponentName();
          invalidFields.push(errorDO)
          validationOutput.isInvalid = true;
          validationOutput.errorDOs = invalidFields;
          
          this.EmitComponentOutput(validationOutput)
        }else{
          this.EmitComponentOutput(this.emailList);
        }
      }
    })
  }

  validateOutput(o) {
    if (o) {
      this.commonUtilty.markAllFieldDirty(o);
      // return o.valid();
      //return true

      
      // if (Array.isArray(validationOutput.errorDOs) && validationOutput.errorDOs.length > 0) {
      //   validationOutput.isInvalid = true;
      // }
      // else {
      //   validationOutput.isInvalid = false;
      // }
      // return validationOutput
    }
  }

  //Initializations
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }
    this.initializeClientSearchForm(this._inputDataForEdit)
    this.subscribeToParentEvent()

  }


  /**
   * Form Trasactions
   */

  initializeClientSearchForm(data?) {
    let payload = data || {}
    this.uiMultirowBasicForm = this.fb.group({
      typeCd: this.validationUtilService.setValidationsForFormControl('typeCd', this.UIMULTIROWBASICFORMNAME, payload['typeCd']),
      emailId: this.validationUtilService.setValidationsForFormControl('emailId', this.UIMULTIROWBASICFORMNAME, payload['emailId'], null, this.commonUtilty.deepCopy(this.emailFieldValidation)),
      id: this.validationUtilService.setValidationsForFormControl('id', this.UIMULTIROWBASICFORMNAME, payload['id']),
      prefferedFl: this.validationUtilService.setValidationsForFormControl('prefferedFl', this.UIMULTIROWBASICFORMNAME, payload['prefferedFl']),
    });
  }

  isRequired(fieldName, formName?) {
    let nameOfForm = null
    if (formName) {
      nameOfForm = formName
    }
    else {
      nameOfForm = this.UIMULTIROWBASICFORMNAME
    }
    let returnObj = this.validationUtilService.isRequired(fieldName, nameOfForm)
    return returnObj
  }
  phoneList: any = [];
  emailList: any = [];

  addRow() {

    if (this.uiMultirowBasicForm.status === 'VALID') {
      // if Email is blank do nothing else for invalid email show error message
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.uiMultirowBasicForm.value.emailId)) {
        this.addEmailToList();      
        //this.EmitComponentOutput(this.emailList)
      }
      else if(this.uiMultirowBasicForm.value.emailId){
        this.notification.error('Not Valid', 'Please enter valid email');
      }

      this.searchHasData = true;
      this.initializeClientSearchForm()
    }
  }

  removeRow(index) {
    this.emailList.splice(index, 1)
  }


  addEmailToList(){
    let clientEmailDO = new ClientEmailDO();
    clientEmailDO.typeCd = this.uiMultirowBasicForm.value.typeCd;
    clientEmailDO.emailId = this.uiMultirowBasicForm.value.emailId;
    if (this.emailList && this.emailList.length == 0)
      this.uiMultirowBasicForm.value.prefferedFl = true;
    clientEmailDO.prefferedFl = this.uiMultirowBasicForm.value.prefferedFl;
    clientEmailDO.id = this.uiMultirowBasicForm.value.id;
    this.emailList =this.commonUtilty.uniquePushInArray(this.emailList, clientEmailDO);
    this.emailList = this.checkDuplicateEntry(this.emailList);
  }
  
  checkDuplicateEntry(emailList){
    var newArray = [];
    if(this.commonUtilty.isArrayIterable(emailList)){
      var lookupObject  = {};

      emailList.forEach(element => {
        if(!lookupObject[element.emailId+'-'+element.typeCd]){
          lookupObject[element.emailId+'-'+element.typeCd] = element;
        }
      });

      for(var i in lookupObject) {
        newArray.push(lookupObject[i]);
      }

      return newArray;
    }
    return newArray;
  }


  deselectOtherEmailsPrefferedFl(preIndex) {
    this.emailList.forEach((element, index) => {
      if (preIndex != index) element.prefferedFl = false
    });
  }

  mobLengthVal = true
  onMobChange(event) {
    let mob = this.uiMultirowBasicForm.get('phone').value;
    if (mob.length < 10)
      this.mobLengthVal = false
  }


  // transform inside component
  UItoServerTransform(payload, response) {
    let DO = this.commonUtilty.getDOName(payload)
    if (payload) {
      payload['providerClientDO']['clientEmailList'] = this.commonUtilty.deepCopy(response.componentData) //deepcopy
    }
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  ServerToUITransform(payload) {
    let DO = this.commonUtilty.getDOName(payload);
    // let output = [];
    if (payload && payload[DO] && payload["providerClientDO"] ) {

      if (this.commonUtilty.isArrayIterable(payload['providerClientDO']['clientEmailList'])) {
        this.emailList = payload['providerClientDO']['clientEmailList']
      }
    }
    // return output;
  }
}
